<script lang="ts">
    import type { Gender } from "../../dictionary/Gender";

    import type { Language } from "../../dictionary/Language";
    import type { LexicalCategory } from "../../dictionary/LexicalCategory";
    import type { Scope } from "../../dictionary/Scope";
    import { Word } from "../../dictionary/Word";

    import InputField from "../../materialize/forms/InputField.svelte";
    import Select from "../../materialize/forms/Select.svelte";
    import Switch from "../../materialize/forms/Switch.svelte";
    import TextField from "../../materialize/forms/TextField.svelte";
    import Column from "../../materialize/grid/Column.svelte";
    import Row from "../../materialize/grid/Row.svelte";
    import {
        genders,
        lexical_categories,
        numbers,
        scopes,
    } from "../../stores/stores";

    export let language: Language;

    let new_word = new Word({});
    function retrieve_results() {}
</script>

<form autocomplete="off" on:submit|preventDefault={retrieve_results}>
    <Row>
        <Column small={12}>
            <h1>Aggiungi parola</h1>
        </Column>
    </Row>
    <Row>
        <Column small={12}>
            <InputField>
                <TextField
                    bind:value={new_word.word}
                    required={true}
                    label_text="Parola"
                    id="field_word"
                />
            </InputField>
        </Column>
    </Row>
    <Row>
        <Column small={12} large={6}>
            <InputField>
                <TextField
                    bind:value={new_word.definition}
                    id="field_word_definition"
                    label_text="Definizione"
                />
            </InputField>
        </Column>
        <Column small={12} large={6}>
            <InputField helper_text_success="Già selezionato">
                <Select
                    options={$lexical_categories.map((e) =>
                        e.format_for_selectform()
                    )}
                    bind:value={new_word.lexical_category}
                    required={false}
                    label="Categoria lessicale"
                />
            </InputField>
        </Column>
        <Column small={12} large={6}>
            <InputField helper_text_success="Già selezionato">
                <Select
                    options={$genders.map((e) => e.format_for_selectform())}
                    bind:value={new_word.gender}
                    required={false}
                    label="Genere"
                />
            </InputField>
        </Column>
        <Column small={12} large={6}>
            <InputField helper_text_success="Già selezionato">
                <Select
                    options={$numbers.map((e) => e.format_for_selectform())}
                    bind:value={new_word.number}
                    required={false}
                    label="Numero"
                />
            </InputField>
        </Column>

        <Column small={12} large={6}>
            <InputField helper_text_success="Già selezionato">
                <Select
                    options={$scopes.map((e) => e.format_for_selectform())}
                    bind:value={new_word.scope}
                    required={false}
                    label="Categoria lessicale"
                />
            </InputField>
        </Column>
        <Column small={12} large={6}>
            <InputField
                helper_text="È un neologismo?"
                helper_text_success="Già selezionato"
            >
                <Switch
                    text_off="No"
                    text_on="Sì"
                    bind:value={new_word.neologism}
                />
            </InputField>
        </Column>
    </Row>
</form>
